class Config {
    constructor() {
        this.$html = document.getElementsByTagName("html")[0];

        this.$document = document;

        this.$body = document.body;

        this.windoInfo = {
            width: 1,
            height: 1
        };

        this.events = {
            WINDOW_RESIZE: "window:resize",
            WINDOW_GET_INFO: "window:hasGetInfo",
            RESIZE: "resize",
            CLICK: "click",
            KEYUP: "keyup",
            MOUSEOVER: "mouseover",
            MOUSEENTER: "mouseenter",
            MOUSELEAVE: "mouseleave",
            SCREEN_UPDATED: "screen:updated",
            SECTION_CHANGE: "section:change",
            PAGINATION_CHANGE: "pagination:change",
            NAVIGATOR_HOVER: "navigator:hover",
            LOADER_EXIT: "loader:exit",
            LOADER_GONE: "loader:gone",
            BORDERS_CHANGE: "borders:change",
            SCROLL: "scroll:adjusted",
            SCROLL_NATIVE: "scroll",
            ORIENTATION_CHANGE: "orientationchange",
            MOUSEWHEEL: "/Firefox/i.test(navigator.userAgent)"
                ? "DOMMouseScroll"
                : "mousewheel"
        };

        this.classes = {
            ACTIVE: "is-active",
            INACTIVE: "is-inactive",
            VISIBLE: "is-visible",
            HIDDEN: "is-hidden",
            NO_SCROLL: "no-scroll",
            FIXED: "is-fixed",
            LOADED: "is-loaded",
            ANIMATED: "is-animated"
        };

    }

    elementInViewport(el) {

        let rect = el.getBoundingClientRect();
        let html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }
}

export default new Config();
